import categories from './categories';
import fields from './fields';

export default {
  /**
   * Set up the Algolia credentials
   */
  algolia_app_id: '8VOK4WOPYE',
  algolia_api_key: 'a32630f310e8bde72e07a235bdadda86',
  algolia_index: 'MONM-LAW',

  /**
   * Set up Analytics info for tracking survey responses
   */
  analytics_id: 'UA-130768066-14',

  /**
   * Set up the Google Sheet information so it can make requests to the right place
   */
  google_sheet_title: 'MONM-Law-2019-DB',
  project_id: 1,

  /**
   * The expiration date of the survey, where no more submissions will be accepted
   * Format: 'July 3, 2018'
   */
  expiration_date: 'May 8, 2019',

  /**
   * Set some variables for the display of the survey
   */
  survey_title: 'Monmouth Top Lawyers - 2019',
  survey_subtitle: 'Legal Professionals',
  social_title: 'Cast your vote for the Top Lawyer in Monmouth!',
  publication_logo: 'https://s3-us-west-2.amazonaws.com/monmouthvoting.com/monm_logo.png',
  welcome_title: 'Welcome!',
  welcome: '<strong>Monmouth Health & Life Magazine</strong> and <strong>DataJoe</strong> are conducting a survey campaign to identify the Top Lawyers in the region. Please nominate your respected peers who exemplify excellence in the legal profession. Please vote for lawyers that you have personally observed in action. Choose professionals you would trust to represent your own friends and loved ones.',
  rules: [
    'You may only submit one ballot per year.',
    'You must have a current AND active New Jersey license (bar number).',
    'You must practice within the Monmouth County area',
    'Submit your ballot before May 7th!',
  ],
  categories,
  fields,
  votes_per_category: 3,
  write_in_limit: 10,
  vote_requirement: 1,

  /**
   * Set some defaults for values that get manipulated while the survey is being filled out
   */
  vote_count: 0,
  uuid: '',
};
